import { Alert, Card, CardBody, Col, Placeholder, Row } from 'react-bootstrap';
import { RestaurantData } from '../..';
import { useLazyGetrestaurantBankDataQuery } from '../../../../../redux/services/restaurantServices';
import { useEffect } from 'react';
import { formatTimestamp } from '../../../../../utility/Utility';
import './index.css';

export interface RestaurantDataProps {
    restaurantData: RestaurantData | undefined;
}

const RestaurantWallet: React.FC<RestaurantDataProps> = ({ restaurantData }) => {
    const restaurantId = restaurantData?.id || restaurantData?.restaurantId;

    const [trigger, { data, isLoading, error }] = useLazyGetrestaurantBankDataQuery();

    useEffect(() => {
        if (restaurantId) {
            trigger(restaurantId);
        }
    }, [restaurantId, trigger]);

    return (
        <div className="carts-view-wallet-whole-body">
            {isLoading ? (<>
                <div className='d-flex justify-content-center'>
                    <Placeholder animation="glow">
                        <Placeholder xs={6} />
                    </Placeholder></div>
                <Card className="carts-view-wallet-upper-cards-left-card">
                    <CardBody>
                        <Row>
                            <Col lg={3}>
                                <Card className="carts-view-wallet-first-card p-2">
                                    <CardBody>
                                        <Placeholder animation="glow">
                                            <Placeholder xs={6} />
                                            <Placeholder xs={6} />
                                        </Placeholder>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg={4}>
                                <Card className='carts-view-wallet-second-card p-2'>
                                    <CardBody>
                                        <Placeholder animation="glow">
                                            <Placeholder xs={6} />
                                            <Placeholder xs={6} />
                                        </Placeholder>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg={5}>
                                <Card className='carts-view-wallet-third-card px-0 py-3'>
                                    <CardBody>
                                        <Placeholder animation="glow">
                                            <Placeholder xs={6} />
                                            <Placeholder xs={6} />
                                        </Placeholder>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card></>) : (<><h4 className='text-warning d-flex justify-content-center'>
                    Details Updated on {formatTimestamp(data?.updatedAt) ?? 0} </h4>
                    <div className="carts-view-wallet-upper-cards">
                        <Card className="carts-view-wallet-upper-cards-left-card">
                            <CardBody>
                                <Row>
                                    <Col lg={3}>
                                        <Card className="carts-view-wallet-first-card p-2">
                                            <CardBody>
                                                <h6>Total Sales</h6>
                                                <h4>
                                                    LKR {(data?.totalSales ?? 0).toFixed(2)}
                                                </h4>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={4}>
                                        <Card className='carts-view-wallet-second-card p-2'>
                                            <CardBody>
                                                <h6>My Earnings</h6>
                                                <h4>
                                                    LKR {(data?.myEarnings ?? 0).toFixed(2)}</h4>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={5}>
                                        <Card className='carts-view-wallet-third-card px-0 py-3'>
                                            <CardBody>
                                                <Row className='d-flex justify-content-between align-items-center'>
                                                    <Col className='fw-bold'>Commissions to Cart</Col>
                                                    <Col>
                                                        LKR {(data?.commissionsToCart ?? 0).toFixed(2)}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='fw-bold'>Payable to Platform</Col>
                                                    <Col>
                                                        LKR {(data?.payableToPlatform ?? 0).toFixed(2)}
                                                    </Col>
                                                </Row>
                                                {error && <Alert variant="danger">Error Loading Data</Alert>}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </div>
                </>)}
        </div>
    )
}

export default RestaurantWallet;